export default {
  namespaced: true,
  state: {
    applicant: {},
    signature: {}
  },
  getters: {
    applicant: state => state.applicant,
    signature: state => state.signature
  },
  mutations: {
    saveApplicant: (state, applicant) => {
      state.applicant = applicant
    },
    saveSignature: (state, signature) => {
      state.signature = signature
    }
  },
  actions: {
    saveApplicant: (context, applicant) => {
      context.commit("saveApplicant", applicant)
    },
    saveSignature: (context, signature) => {
      context.commit("saveSignature", signature)
    }
  }
}
